import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {FilterUtil} from '../../../util/filter.util';
import {RequestType} from '../../../enums/request.type';
import {ListResponse} from '../../../network/service/list.response';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {VerifyOptions} from '../../dialog/verify/options/verify.options';
import {VerifyComponent} from '../../dialog/verify/verify.component';
import {DataResponse} from '../../../network/service/data.response';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-payment-methods',
  standalone: false,
  templateUrl: './payment-methods.component.html',
  styleUrl: './payment-methods.component.scss'
})
export class PaymentMethodsComponent extends BaseComponent implements OnInit {
  branchIds: any = [];
  selectedBranches: any = [];
  paymentMethods: any[] = [];
  selectedPaymentMethod?: any;
  isLoadingPaymentMethods = false;
  editingPaymentMethod: any = {};
  isEditing = false;
  isSubmitting = false;
  iconFiles: any[] = [];
  pspIconFiles: any[] = [];
  uploadedPSPIconId: string = '';
  pspProvider: string = '';
  samanTerminalId: string = '';
  zarinpalMerchantId: string = '';
  melatTerminalId: string = '';
  melatUsername: string = '';
  melatPassword: string = '';
  cards: any[] = [];
  selectedCardIndex: number = -1;
  editingCard: any = {};
  // POS management
  poses: any[] = [];
  selectedPosIndex: number = -1;
  editingPos: any = {};
  typeOptions = [
    {
      Value: 'PSP',
      Title: 'درگاه'
    },
    {
      Value: 'CASH',
      Title: 'نقدی'
    },
    {
      Value: 'WALLET',
      Title: 'کیف پول'
    },
    {
      Value: 'CARD_TO_CARD',
      Title: 'کارت به کارت'
    },
    {
      Value: 'POS',
      Title: 'پوز'
    }
  ];
  pspProviderOptions = [
    {
      Value: 'SAMAN',
      Title: 'بانک سامان'
    },
    {
      Value: 'ZARINPAL',
      Title: 'زرین‌پال'
    },
    {
      Value: 'MELAT',
      Title: 'به پرداخت ملت'
    }
  ];
  selectedType?: any;
  selectedPSPProvider?: any;
  allFilters = FilterUtil.DeliveryMethodsFilters;
  filters: any = {};

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.isLoadingPaymentMethods = true;
    this.serviceApi.getPaymentMethods(undefined, undefined, 'PaymentMethodBranches,PaymentMethodBranches.Branch', RequestType.ALL, undefined, {
      Filter: this.filters,
    }).subscribe((res: ListResponse<any>) => {
      this.isLoadingPaymentMethods = false;
      if (res.success) {
        this.paymentMethods = res.data || [];
        if (this.paymentMethods && this.paymentMethods.length > 0) {
          this.selectedPaymentMethod = this.paymentMethods[0];
          this.loadPaymentMethodDetails();
        } else {
          this.selectedPaymentMethod = undefined;
        }
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  onPaymentMethodClick(paymentMethod: any) {
    this.selectedPaymentMethod = paymentMethod;
    this.loadPaymentMethodDetails();
  }

  loadPaymentMethodDetails() {
    if (this.selectedPaymentMethod) {
      this.editingPaymentMethod = {...this.selectedPaymentMethod};
      this.isEditing = true;
      this.loadFormData();
    } else {
      this.resetForm();
    }
  }

  loadFormData() {
    if (this.editingPaymentMethod.Type) {
      this.selectedType = this.typeOptions.find(t => t.Value === this.editingPaymentMethod.Type);
    } else {
      this.selectedType = undefined;
    }
    this.selectedBranches = this.editingPaymentMethod.PaymentMethodBranches.map((paymentMethodBranch: any) => {
      return paymentMethodBranch.Branch;
    });
    this.branchIds = this.editingPaymentMethod.BranchIds;
    if (this.editingPaymentMethod.Type === 'PSP' && this.editingPaymentMethod.Metadata) {
      this.pspProvider = this.editingPaymentMethod.Metadata.PSP || '';
      this.selectedPSPProvider = this.pspProviderOptions.find(p => p.Value === this.pspProvider);
      this.uploadedPSPIconId = this.editingPaymentMethod.Metadata.PSPIcon || '';
      if (this.pspProvider === 'SAMAN') {
        this.samanTerminalId = this.editingPaymentMethod.Metadata.TerminalId || '';
      } else if (this.pspProvider === 'ZARINPAL') {
        this.zarinpalMerchantId = this.editingPaymentMethod.Metadata.MerchantId || '';
      } else if (this.pspProvider === 'MELAT') {
        this.melatTerminalId = this.editingPaymentMethod.Metadata.TerminalId || '';
        this.melatUsername = this.editingPaymentMethod.Metadata.Username || '';
        this.melatPassword = this.editingPaymentMethod.Metadata.Password || '';
      }
    } else {
      this.pspProvider = '';
      this.selectedPSPProvider = undefined;
      this.samanTerminalId = '';
      this.zarinpalMerchantId = '';
      this.uploadedPSPIconId = '';
    }
    if (this.editingPaymentMethod.Type === 'CARD_TO_CARD' && this.editingPaymentMethod.Metadata && this.editingPaymentMethod.Metadata.Cards) {
      this.cards = [...this.editingPaymentMethod.Metadata.Cards];
    } else {
      this.cards = [];
    }
    if (this.editingPaymentMethod.Type === 'POS' && this.editingPaymentMethod.Metadata && this.editingPaymentMethod.Metadata.Poses) {
      this.poses = [...this.editingPaymentMethod.Metadata.Poses];
    } else {
      this.poses = [];
    }
    this.selectedCardIndex = -1;
    this.editingCard = {};
  }

  onCreatePaymentMethodClicked() {
    this.selectedPaymentMethod = null;
    this.resetForm();
    this.isEditing = false;
  }

  onUpdatePaymentMethodClicked(paymentMethod: any) {
    this.selectedPaymentMethod = paymentMethod;
    this.loadPaymentMethodDetails();
  }

  onDeletePaymentMethodClicked(paymentMethod: any) {
    let verifyOptions = new VerifyOptions();
    verifyOptions.message = 'آیا از حذف روش پرداخت مطمئن هستید؟';
    let verifyComponent = this.matDialog.open(VerifyComponent);
    verifyOptions.onNoClicked = () => {
      verifyComponent.close();
    };
    verifyOptions.onYesClicked = () => {
      this.serviceApi.deletePaymentMethods(paymentMethod.PaymentMethodId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          verifyComponent.close();
          this.loadOnline();
          if (this.selectedPaymentMethod?.PaymentMethodId === paymentMethod.PaymentMethodId) {
            this.selectedPaymentMethod = undefined;
            this.resetForm();
          }
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    };
    verifyComponent.componentInstance.verifyOptions = verifyOptions;
  }

  onTypeSelect(type?: any) {
    if (type) {
      this.editingPaymentMethod.Type = type.Value;
      this.selectedType = type;
      this.clearTypeSpecificData();
    }
  }

  onPSPProviderSelect(provider?: any) {
    if (provider) {
      this.pspProvider = provider.Value;
      this.selectedPSPProvider = provider;
      this.samanTerminalId = '';
      this.zarinpalMerchantId = '';
    }
  }

  clearTypeSpecificData() {
    this.pspProvider = '';
    this.selectedPSPProvider = undefined;
    this.samanTerminalId = '';
    this.zarinpalMerchantId = '';
    this.melatTerminalId = '';
    this.melatUsername = '';
    this.melatPassword = '';
    this.uploadedPSPIconId = '';
    this.editingPaymentMethod.WalletAddress = '';
    this.editingPaymentMethod.BankName = '';
    this.editingPaymentMethod.CardNumber = '';
    this.editingPaymentMethod.CardholderName = '';
    this.editingPaymentMethod.MaximumAmount = '';
    this.editingPaymentMethod.Radius = 1000;
    this.editingPaymentMethod.Latitude = undefined;
    this.editingPaymentMethod.Longitude = undefined;
    this.cards = [];
    this.selectedCardIndex = -1;
    this.editingCard = {};
    this.poses = [];
    this.selectedPosIndex = -1;
    this.editingPos = {};
  }

  onSubmitPaymentMethod() {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    if (this.editingPaymentMethod.Type === 'PSP' && this.pspIconFiles && this.pspIconFiles.length > 0) {
      this.uploadPSPIcon(() => {
        this.createOrUpdatePaymentMethod();
      });
    } else {
      this.createOrUpdatePaymentMethod();
    }
  }

  uploadPSPIcon(callback: () => void) {
    const file = this.pspIconFiles[0];
    if (file) {
      if (file instanceof File) {
        let formData = new FormData();
        formData.append('File', file);
        this.serviceApi.upload(formData).subscribe((res: DataResponse<any>) => {
          if (res.success) {
            this.uploadedPSPIconId = res.data.dataValues.FileId;
            callback();
          } else {
            this.isSubmitting = false;
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
      } else {
        this.uploadedPSPIconId = file.name;
        callback();
      }
    } else {
      this.uploadedPSPIconId = '';
      callback();
    }
  }

  createOrUpdatePaymentMethod() {
    let metadata: any = {};
    if (this.editingPaymentMethod.Type === 'PSP') {
      metadata.PSP = this.pspProvider;
      if (this.pspProvider === 'SAMAN') {
        metadata.TerminalId = this.samanTerminalId;
      } else if (this.pspProvider === 'ZARINPAL') {
        metadata.MerchantId = this.zarinpalMerchantId;
      } else if (this.pspProvider === 'MELAT') {
        metadata.TerminalId = this.melatTerminalId;
        metadata.Username = this.melatUsername;
        metadata.Password = this.melatPassword;
      }
      if (this.uploadedPSPIconId) {
        metadata.PSPIcon = this.uploadedPSPIconId;
      }
    } else if (this.editingPaymentMethod.Type === 'CARD_TO_CARD') {
      metadata = {
        Cards: this.cards
      };
    } else if (this.editingPaymentMethod.Type === 'WALLET') {
      metadata = {
        WalletAddress: this.editingPaymentMethod.WalletAddress
      };
    } else if (this.editingPaymentMethod.Type === 'POS') {
      metadata = {
        Poses: this.poses
      };
    }
    let paymentMethodData: any = {
      Title: this.editingPaymentMethod.Title,
      Type: this.editingPaymentMethod.Type,
      BranchIds: this.branchIds,
      Metadata: metadata,
      IsActive: this.editingPaymentMethod.IsActive ?? true
    };
    if (this.editingPaymentMethod.Type === 'CASH') {
      paymentMethodData.Latitude = this.editingPaymentMethod.Latitude;
      paymentMethodData.Longitude = this.editingPaymentMethod.Longitude;
      paymentMethodData.Radius = this.editingPaymentMethod.Radius;
    }
    const apiCall = this.isEditing && this.editingPaymentMethod.PaymentMethodId
      ? this.serviceApi.updatePaymentMethods(this.editingPaymentMethod.PaymentMethodId, paymentMethodData)
      : this.serviceApi.createPaymentMethods(paymentMethodData);
    apiCall.subscribe((res: DataResponse<any>) => {
      this.isSubmitting = false;
      if (res.success) {
        this.loadOnline();
        if (this.isEditing && this.editingPaymentMethod.PaymentMethodId) {
          this.selectedPaymentMethod = {...this.editingPaymentMethod, ...paymentMethodData};
        } else {
          this.selectedPaymentMethod = res.data;
        }
        this.loadPaymentMethodDetails();
        SnackBarUtil.makeMessage(this, 'عملیات با موفقیت انجام شد', res.success);
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  onCancelEdit() {
    if (this.selectedPaymentMethod) {
      this.loadPaymentMethodDetails();
    } else {
      this.resetForm();
    }
  }

  resetForm() {
    this.editingPaymentMethod = {
      Title: '',
      Type: '',
      IsActive: true,
      Latitude: undefined,
      Longitude: undefined,
      Radius: 1000,
      WalletAddress: '',
      BankName: '',
      CardNumber: '',
      CardholderName: '',
      MaximumAmount: ''
    };
    this.pspProvider = '';
    this.samanTerminalId = '';
    this.zarinpalMerchantId = '';
    this.melatTerminalId = '';
    this.melatUsername = '';
    this.melatPassword = '';
    this.uploadedPSPIconId = '';
    this.selectedType = undefined;
    this.selectedPSPProvider = undefined;
    this.iconFiles = [];
    this.pspIconFiles = [];
    this.cards = [];
    this.selectedCardIndex = -1;
    this.editingCard = {};
    this.isEditing = false;
  }

  getSelectedPaymentMethodTitle(): string {
    if (this.selectedPaymentMethod) {
      return this.selectedPaymentMethod.Title || '';
    }
    return 'انتخاب روش پرداخت';
  }

  getPaymentMethodTypeTitle(type: string): string {
    const typeMap: { [key: string]: string } = {
      'PSP': 'درگاه',
      'CASH': 'نقدی',
      'WALLET': 'کیف پول',
      'CARD_TO_CARD': 'کارت به کارت'
    };
    return typeMap[type] || type;
  }

  onAddCard() {
    this.editingCard = {
      BankName: '',
      CardNumber: '',
      CardholderName: '',
      PaymentPercentage: '',
      MaximumAmount: '',
      DefaultCard: false,
    };
    this.selectedCardIndex = -1;
    this.cards.push({...this.editingCard});
    this.selectedCardIndex = this.cards.length - 1;
    this.updateCardOrders();
  }

  onEditCard(card: any, index: number) {
    this.editingCard = {...card};
    this.selectedCardIndex = index;
  }

  onSaveCard() {
    if (this.selectedCardIndex >= 0) {
      this.cards[this.selectedCardIndex] = {...this.editingCard};
      this.updateCardOrders();
      this.onCancelCardEdit();
    }
  }

  onDeleteCard(index: number) {
    this.cards.splice(index, 1);
    this.updateCardOrders();
    if (this.selectedCardIndex === index) {
      this.onCancelCardEdit();
    } else if (this.selectedCardIndex > index) {
      this.selectedCardIndex--;
    }
  }

  onCancelCardEdit() {
    if (this.selectedCardIndex >= 0 && this.selectedCardIndex === this.cards.length - 1) {
      const lastCard = this.cards[this.cards.length - 1];
      if (!lastCard.BankName && !lastCard.CardNumber && !lastCard.CardholderName) {
        this.cards.splice(this.cards.length - 1, 1);
      }
    }
    this.editingCard = {};
    this.selectedCardIndex = -1;
  }

  getCardDisplayName(card: any): string {
    return `${card.BankName} - ${card.CardNumber}`;
  }

  onCardDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.cards, event.previousIndex, event.currentIndex);
    this.updateCardOrders();
  }

  updateCardOrders() {
    this.cards.forEach((card, index) => {
      card.Order = index + 1;
    });
  }

  // POS management methods
  onAddPos() {
    const newPos = {
      BankName: '',
      TerminalIp: '',
      TerminalPort: ''
    };
    this.poses.push(newPos);
    this.selectedPosIndex = this.poses.length - 1;
    this.editingPos = {...newPos};
    this.updatePosesInMetadata();
  }

  onEditPos(pos: any, index: number) {
    this.selectedPosIndex = index;
    this.editingPos = {...pos};
  }

  onSavePos() {
    if (this.selectedPosIndex >= 0 && this.selectedPosIndex < this.poses.length) {
      this.poses[this.selectedPosIndex] = {...this.editingPos};
      this.updatePosesInMetadata();
    }
    this.selectedPosIndex = -1;
    this.editingPos = {};
  }

  onDeletePos(index: number) {
    if (index >= 0 && index < this.poses.length) {
      this.poses.splice(index, 1);
      this.updatePosesInMetadata();
    }
    if (this.selectedPosIndex === index) {
      this.selectedPosIndex = -1;
      this.editingPos = {};
    } else if (this.selectedPosIndex > index) {
      this.selectedPosIndex--;
    }
  }

  onCancelPosEdit() {
    this.selectedPosIndex = -1;
    this.editingPos = {};
  }

  updatePosesInMetadata() {
    if (this.editingPaymentMethod.Metadata) {
      this.editingPaymentMethod.Metadata.Poses = [...this.poses];
    } else {
      this.editingPaymentMethod.Metadata = {Poses: [...this.poses]};
    }
  }

  onPosDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.poses, event.previousIndex, event.currentIndex);
    this.updatePosesInMetadata();
  }

  updatePaymentMethodWithCards() {
    if (!this.selectedPaymentMethod || !this.isEditing) {
      return;
    }
    this.editingPaymentMethod.Metadata = {
      Cards: this.cards
    };
    this.selectedPaymentMethod.Metadata = {
      Cards: this.cards
    };
  }
}
